module.exports = __webpack_public_path__ + "static/media/planetera.2f103b4f.png";